import { FC } from 'react';
import { Image } from 'antd';

import { IMAGES_FALLBACK_SRC } from 'entities/application/constants';
import { ApplicationStatus } from 'entities/application/ui/ApplicationStatus/ApplicationStatus';
import { useSubscriptionStatus } from 'entities/tariff/model/useSubscriptionStatus';
import { LogoCoverStyled } from './ApplicationLogoContainer.styles';

interface Props {
	logoBgr: string;
	logoUrl: string;
	name: string;
	status?: 'beta' | 'development' | 'new' | 'updated';
	applicationId: string;
}

export const ApplicationLogoContainer: FC<Props> = ({ logoBgr, logoUrl, name, status, applicationId }) => {
	const subscriptionStatus = useSubscriptionStatus(applicationId);

	return (
		<LogoCoverStyled style={{ backgroundImage: `url(${logoBgr})` }}>
			<Image
				alt={`Логотип приложения ${name}`}
				src={logoUrl}
				preview={false}
				fallback={IMAGES_FALLBACK_SRC}
				style={{ maxHeight: `120px`, maxWidth: `120px` }}
			/>
			{(status || !!subscriptionStatus.status) && (
				<div style={{ position: `absolute`, top: `12px`, right: `12px` }}>
					<ApplicationStatus
						status={
							// eslint-disable-next-line no-nested-ternary
							status
						}
					/>
				</div>
			)}
		</LogoCoverStyled>
	);
};
